import React from "react";

// mui icon importing
import EventNoteIcon from '@mui/icons-material/EventNote';

const FormTitle = () => {

  return (
    <div className="flex justify-between font-semibold text-white pl-5 pr-5 items-center w-full h-[3rem] bg-primary rounded-t-md">
      {/* text */}
      <p>BIỂU MẪU XÁC NHẬN</p>

      {/* icon */}
      <EventNoteIcon />
    </div>
  )
}

export default FormTitle;
